module.exports = __webpack_public_path__ + "img/banner-empty1.1d73ac79.png";